// PrInformationModal.jsx (buo na - walang binago sa structure, intact ang cache at lahat)
import React, { lazy, useEffect, useState, Suspense, useRef, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Modal, Spin, Descriptions, Icon, message } from 'antd';

// Lazy load child components for better performance
const PrItemTable = lazy(() => import('./PrItemTable'));
const PoDetails = lazy(() => import('./PoDetails'));
const PrSummary = lazy(() => import('./PrSummary'));

const modalStyles = `
@keyframes cd-bar {
  0%   { background-position: 0% center; }
  100% { background-position: 200% center; }
}
@keyframes cd-glow {
  0%, 100% { box-shadow: 0 0 0 0 rgba(24,144,255,0.4); }
  50%       { box-shadow: 0 0 0 10px rgba(0,0,0,0); }
}
@keyframes modal-pop {
  from { opacity: 0; transform: scale(0.96) translateY(12px); }
  to   { opacity: 1; transform: scale(1) translateY(0); }
}
@keyframes progress-pulse {
  0% { opacity: 0.6; width: 0%; }
  50% { opacity: 1; width: 70%; }
  100% { opacity: 0.6; width: 100%; }
}

.cd-modal .ant-modal-content {
  border-radius: 14px !important;
  overflow: hidden !important;
  box-shadow: 0 24px 64px rgba(0,0,0,0.16), 0 0 0 1px rgba(24,144,255,0.1) !important;
  animation: modal-pop 0.3s cubic-bezier(.22,1,.36,1) both !important;
}
.cd-modal .ant-modal-header {
  padding: 0 !important;
  border-bottom: none !important;
}
.cd-modal .ant-modal-body {
  padding: 0 !important;
  overflow: visible !important;      /* ensure no scroll on modal body */
}
.cd-modal .ant-modal-footer {
  display: none !important;
}
.cd-modal .ant-modal-close {
  top: 14px !important;
  right: 16px !important;
  color: rgba(255,255,255,0.8) !important;
  transition: color 0.2s, transform 0.2s !important;
  z-index: 10;
}
.cd-modal .ant-modal-close:hover {
  color: #fff !important;
  transform: rotate(90deg) !important;
}
.cd-modal .ant-modal-close .ant-modal-close-x {
  width: 36px !important;
  height: 36px !important;
  line-height: 36px !important;
}

.progress-bar {
  animation: progress-pulse 1.5s ease-in-out infinite;
  height: 2px;
  background: linear-gradient(90deg, #003a8c, #1890ff, #003a8c);
  border-radius: 2px;
}

.cd-header {
  background: linear-gradient(135deg, #003a8c 0%, #0050b3 35%, #096dd9 70%, #003a8c 100%);
  padding: 18px 22px 16px;
  display: flex;
  align-items: center;
  gap: 14px;
  position: relative;
  overflow: hidden;
}
.cd-header::before {
  content: '';
  position: absolute;
  inset: 0;
  background-image: radial-gradient(rgba(255,255,255,0.09) 1px, transparent 1px);
  background-size: 20px 20px;
  pointer-events: none;
}
.cd-header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #13c2c2, #1890ff, #52c41a, #fa8c16, #13c2c2);
  background-size: 300% auto;
  animation: cd-bar 3s linear infinite;
}
.cd-header-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(255,255,255,0.15);
  border: 1.5px solid rgba(255,255,255,0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  animation: cd-glow 2.6s ease-in-out infinite;
}
.cd-header-icon svg {
  width: 22px;
  height: 22px;
}
.cd-header-title {
  font-size: 15px;
  font-weight: 800;
  color: #fff;
  letter-spacing: 0.8px;
}
.cd-header-sub {
  font-size: 11px;
  color: rgba(255,255,255,0.6);
  letter-spacing: 1px;
  margin-top: 2px;
}

.cd-body {
  padding: 20px 22px;
  /* SCROLL REMOVED: no max-height, no overflow auto */
  overflow: visible;
  background: #fff;
}
.cd-body .ant-descriptions-title {
  font-size: 14px;
  font-weight: 700;
  color: #1890ff;
  margin-bottom: 16px;
}
.cd-body .ant-descriptions-bordered .ant-descriptions-item-label {
  background: #fafcff;
  font-weight: 600;
  color: #595959;
}
.cd-body .ant-descriptions-bordered .ant-descriptions-item-content {
  background: #fff;
  color: #262626;
}

.cd-section-title {
  font-size: 14px;
  font-weight: 700;
  color: #1890ff;
  margin: 20px 0 12px 0;
  padding-bottom: 6px;
  border-bottom: 2px solid #e6f0ff;
  display: flex;
  align-items: center;
  gap: 8px;
}

.cd-spin-container {
  min-height: 400px;
  background: #fff;
  border-radius: 0 0 14px 14px;
  overflow: visible;           /* no scrolling inside spin container */
}

/* Lightning fast table styles - DARK BLUE HEADER */
.cd-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
}
.cd-table th {
  background: linear-gradient(135deg, #003a8c 0%, #0050b3 50%, #096dd9 100%);
  color: #fff;
  padding: 12px 8px;
  font-weight: 600;
  font-size: 12px;
  text-align: center;
  border: 1px solid #003a8c;
}
.cd-table td {
  padding: 10px 8px;
  background: #fff;
  border: 1px solid #e8f0fe;
  color: #1e293b;
  transition: all 0.2s ease;
}
.cd-table tr:hover td {
  background: #e6f7ff;
}
.cd-table .matched-row td {
  background: #e6f7ff;
  position: relative;
}
.cd-table .matched-row td::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: #003a8c;
}
`;

// ============================================================
// PERSISTENT CACHE WITH LOCALSTORAGE + AUTO DELETE AFTER 2 HOURS
// ============================================================
class PersistentCache {
  constructor(storagePrefix = 'pr_details_', maxAgeHours = 2) {
    this.storagePrefix = storagePrefix;
    this.maxAgeMs = maxAgeHours * 60 * 60 * 1000;
    this.memoryCache = new Map();
    this.stats = {
      hits: 0,
      misses: 0,
      localStorageLoads: 0
    };
    
    this.cleanExpired();
    this.cleanupInterval = setInterval(() => this.cleanExpired(), 30 * 60 * 1000);
  }
  
  destroy() {
    if (this.cleanupInterval) {
      clearInterval(this.cleanupInterval);
    }
  }
  
  getKey(key) {
    return `${this.storagePrefix}${key}`;
  }
  
  set(key, data, metadata = {}) {
    const cacheKey = this.getKey(key);
    const cacheEntry = {
      data: data,
      timestamp: Date.now(),
      expiry: Date.now() + this.maxAgeMs,
      version: '1.0',
      ...metadata
    };
    
    try {
      this.memoryCache.set(cacheKey, cacheEntry);
      localStorage.setItem(cacheKey, JSON.stringify(cacheEntry));
      console.log(`💾 Cached: ${key}`, { 
        expiresIn: `${Math.floor(this.maxAgeMs / 3600000)} hours`,
        memorySize: this.memoryCache.size 
      });
      return true;
    } catch (error) {
      if (error.name === 'QuotaExceededError') {
        console.warn('Storage quota exceeded, clearing old cache...');
        this.clearOldest();
        try {
          localStorage.setItem(cacheKey, JSON.stringify(cacheEntry));
        } catch (e) {
          console.error('Failed to save after cleanup:', e);
        }
      }
      return false;
    }
  }
  
  get(key) {
    const cacheKey = this.getKey(key);
    
    if (this.memoryCache.has(cacheKey)) {
      const entry = this.memoryCache.get(cacheKey);
      if (entry.expiry > Date.now()) {
        this.stats.hits++;
        const age = Math.floor((Date.now() - entry.timestamp) / 1000);
        console.log(`⚡ Memory cache HIT: ${key} (${age}s old)`);
        return entry;
      } else {
        this.memoryCache.delete(cacheKey);
      }
    }
    
    try {
      const stored = localStorage.getItem(cacheKey);
      if (stored) {
        this.stats.localStorageLoads++;
        const entry = JSON.parse(stored);
        if (entry.expiry > Date.now()) {
          this.memoryCache.set(cacheKey, entry);
          this.stats.hits++;
          const age = Math.floor((Date.now() - entry.timestamp) / 1000);
          console.log(`📦 localStorage cache HIT: ${key} (${age}s old)`);
          return entry;
        } else {
          localStorage.removeItem(cacheKey);
          console.log(`⏰ Expired cache removed: ${key}`);
        }
      }
    } catch (error) {
      console.error('Error reading from localStorage:', error);
    }
    
    this.stats.misses++;
    console.log(`❌ Cache MISS: ${key}`);
    return null;
  }
  
  has(key) {
    const cacheKey = this.getKey(key);
    
    if (this.memoryCache.has(cacheKey)) {
      const entry = this.memoryCache.get(cacheKey);
      if (entry.expiry > Date.now()) {
        return true;
      }
    }
    
    try {
      const stored = localStorage.getItem(cacheKey);
      if (stored) {
        const entry = JSON.parse(stored);
        if (entry.expiry > Date.now()) {
          return true;
        }
      }
    } catch (error) {}
    
    return false;
  }
  
  delete(key) {
    const cacheKey = this.getKey(key);
    this.memoryCache.delete(cacheKey);
    localStorage.removeItem(cacheKey);
    console.log(`🗑️ Deleted cache: ${key}`);
    return true;
  }
  
  cleanExpired() {
    const now = Date.now();
    let cleanedCount = 0;
    
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(this.storagePrefix)) {
        try {
          const entry = JSON.parse(localStorage.getItem(key));
          if (entry.expiry <= now) {
            localStorage.removeItem(key);
            cleanedCount++;
          }
        } catch (error) {
          localStorage.removeItem(key);
          cleanedCount++;
        }
      }
    }
    
    for (const [key, entry] of this.memoryCache.entries()) {
      if (entry.expiry <= now) {
        this.memoryCache.delete(key);
        cleanedCount++;
      }
    }
    
    if (cleanedCount > 0) {
      console.log(`🧹 Cleaned ${cleanedCount} expired cache entries`);
    }
  }
  
  clearOldest() {
    const items = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(this.storagePrefix)) {
        try {
          const entry = JSON.parse(localStorage.getItem(key));
          items.push({ key, timestamp: entry.timestamp });
        } catch (error) {}
      }
    }
    
    items.sort((a, b) => a.timestamp - b.timestamp);
    const toRemove = Math.ceil(items.length * 0.2);
    for (let i = 0; i < toRemove; i++) {
      localStorage.removeItem(items[i].key);
      this.memoryCache.delete(items[i].key);
      console.log(`🗑️ Removed oldest cache: ${items[i].key}`);
    }
  }
  
  clearAll() {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(this.storagePrefix)) {
        localStorage.removeItem(key);
      }
    }
    this.memoryCache.clear();
    console.log('🧹 All cache cleared');
  }
  
  getStats() {
    let totalSize = 0;
    let itemCount = 0;
    
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(this.storagePrefix)) {
        const item = localStorage.getItem(key);
        totalSize += item ? item.length : 0;
        itemCount++;
      }
    }
    
    return {
      ...this.stats,
      memoryItems: this.memoryCache.size,
      localStorageItems: itemCount,
      totalSizeKB: Math.round(totalSize / 1024),
      hitRate: this.stats.hits + this.stats.misses > 0 
        ? ((this.stats.hits / (this.stats.hits + this.stats.misses)) * 100).toFixed(1)
        : 0
    };
  }
}

// Create singleton instance (2 hours expiry)
const persistentCache = new PersistentCache('pr_details_', 2);

// ============================================================
// OPTIMIZED PR INFORMATION MODAL WITH PERSISTENT CACHE (NO SCROLL)
// ============================================================
const PrInformationModal = (props) => {
  const { visible, getPrDetails, data, closeModal } = props;
  
  const [spin, setSpin] = useState(false);
  const [details, setDetails] = useState({
    prItems: [],
    poDetails: {},
    poItems: [],
    poHistory: [],
  });
  const [progressWidth, setProgressWidth] = useState(0);
  const [loadingCache, setLoadingCache] = useState(false);
  const [usingCache, setUsingCache] = useState(false);
  const [isOnline, setIsOnline] = useState(typeof navigator !== 'undefined' ? navigator.onLine : true);
  const [cacheInfo, setCacheInfo] = useState(null);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  
  const pendingRequest = useRef(null);
  const loadingInterval = useRef(null);
  const abortController = useRef(null);
  const isMounted = useRef(true);
  const fetchFunctionRef = useRef(null);
  
  // ============ MEMOIZED VALUES ============
  
  // Memoized PR total calculation
  const prTotal = useMemo(() => {
    return details.prItems.reduce((acc, val) => acc + (val.amount || 0), 0);
  }, [details.prItems]);
  
  // Memoized item total budget calculation
  const itemTotalBudget = useMemo(() => {
    return details.poItems
      .filter((item) => item.isMatchItem)
      .reduce((acc, val) => acc + (val.budgetPriceTotal || 0), 0);
  }, [details.poItems]);
  
  // Memoized check for existing RM
  const hasExistingRm = useMemo(() => {
    return details.poHistory.some((po) => {
      return po.joNumber && po.joNumber.split(',').includes(data?.joNum);
    });
  }, [details.poHistory, data?.joNum]);
  
  // Memoized cache key
  const cacheKey = useMemo(() => {
    return data?.priceId ? `pr_details_${data.priceId}` : null;
  }, [data?.priceId]);
  
  // Memoized handler for closing modal
  const handleCloseModal = useCallback(() => {
    closeModal('pr');
  }, [closeModal]);
  
  // Memoized progress simulation handlers
  const startProgressSimulation = useCallback(() => {
    if (loadingInterval.current) clearInterval(loadingInterval.current);
    setProgressWidth(0);
    
    loadingInterval.current = setInterval(() => {
      setProgressWidth((prev) => {
        if (prev >= 95) return prev;
        return prev + Math.random() * 15;
      });
    }, 200);
  }, []);
  
  const stopProgressSimulation = useCallback(() => {
    if (loadingInterval.current) {
      clearInterval(loadingInterval.current);
      loadingInterval.current = null;
    }
    setProgressWidth(100);
    setTimeout(() => { setProgressWidth(0); }, 300);
  }, []);
  
  // Memoized function to update details with cache info
  const updateDetailsWithCache = useCallback((cachedData, cachedEntry) => {
    if (!isMounted.current) return;
    
    setDetails(cachedData);
    setUsingCache(true);
    setSpin(false);
    setLoadingCache(false);
    
    if (cachedEntry) {
      const cacheAge = Date.now() - cachedEntry.timestamp;
      const cacheAgeSeconds = Math.floor(cacheAge / 1000);
      const cacheAgeMinutes = Math.floor(cacheAgeSeconds / 60);
      
      setCacheInfo({
        age: cacheAgeSeconds,
        ageMinutes: cacheAgeMinutes,
        timestamp: cachedEntry.timestamp,
        expiresIn: Math.floor((cachedEntry.expiry - Date.now()) / 60000)
      });
      
      if (cacheAgeSeconds > 5 && isFirstLoad) {
        message.success(`⚡ Loaded from cache (${cacheAgeMinutes}m ago)`, 1);
      }
    }
    
    setIsFirstLoad(false);
  }, [isFirstLoad]);
  
  // Memoized background refresh function
  const backgroundRefresh = useCallback((cacheAge) => {
    if (isOnline && cacheAge > 30 * 60 * 1000 && fetchFunctionRef.current) {
      console.log('🔄 Background refresh for older cache...');
      setTimeout(() => {
        if (isMounted.current && fetchFunctionRef.current) {
          fetchFunctionRef.current(true);
        }
      }, 100);
    }
  }, [isOnline]);
  
  // Main fetch function with useCallback (FIXED)
  const fetchPrDetailsWithCache = useCallback(async (forceRefresh = false) => {
    if (!data?.priceId) return;
    
    const currentCacheKey = `pr_details_${data.priceId}`;
    
    if (pendingRequest.current && !forceRefresh) {
      console.log('⏳ May pending request, skipping...');
      return pendingRequest.current;
    }
    
    const cachedEntry = persistentCache.get(currentCacheKey);
    
    // Use cache if available and not forcing refresh
    if (cachedEntry && cachedEntry.data && !forceRefresh) {
      const cacheAge = Date.now() - cachedEntry.timestamp;
      
      updateDetailsWithCache(cachedEntry.data, cachedEntry);
      backgroundRefresh(cacheAge);
      
      return cachedEntry.data;
    }
    
    // No cache - fetch from server
    console.log('🌐 No valid cache, fetching from server...');
    startProgressSimulation();
    setLoadingCache(true);
    setSpin(true);
    setUsingCache(false);
    
    try {
      if (isOnline) {
        if (abortController.current) {
          abortController.current.abort();
        }
        
        abortController.current = new AbortController();
        
        const result = await getPrDetails(data.priceId);
        
        if (isMounted.current) {
          const freshDetails = {
            prItems: result.prItems || [],
            poDetails: result.poDetails || {},
            poItems: result.poItems || [],
            poHistory: result.poHistory || [],
          };
          
          setDetails(freshDetails);
          persistentCache.set(currentCacheKey, freshDetails, {
            priceId: data.priceId,
            fetchTime: Date.now()
          });
          
          message.success(`💾 Data saved to cache - Next time will be instant!`, 1.5);
        }
        
        stopProgressSimulation();
        setLoadingCache(false);
        setSpin(false);
        
        return result;
      }
      
      // Offline mode - use expired cache as fallback
      if (cachedEntry && cachedEntry.data) {
        if (isMounted.current) {
          updateDetailsWithCache(cachedEntry.data, cachedEntry);
          message.warning('📴 Offline mode - showing cached data (may be outdated)', 2);
        }
        stopProgressSimulation();
        setLoadingCache(false);
        setSpin(false);
        return cachedEntry.data;
      }
      
      throw new Error('No data available offline');
      
    } catch (error) {
      if (error.name !== 'AbortError' && error.name !== 'CanceledError') {
        console.error('Fetch error:', error);
        message.error('Failed to load data', 1.5);
      }
      stopProgressSimulation();
      setLoadingCache(false);
      setSpin(false);
      // ✅ CRITICAL FIX: set empty details to stop infinite loading
      setDetails({ prItems: [], poDetails: {}, poItems: [], poHistory: [] });
      pendingRequest.current = null;
    }
  }, [data?.priceId, getPrDetails, isOnline, startProgressSimulation, stopProgressSimulation, updateDetailsWithCache, backgroundRefresh]);
  
  // Store fetch function in ref for background refresh
  useEffect(() => {
    fetchFunctionRef.current = fetchPrDetailsWithCache;
  }, [fetchPrDetailsWithCache]);
  
  // Memoized network handlers
  const handleOnline = useCallback(() => {
    setIsOnline(true);
    message.success('🌐 Back online!', 1);
    if (visible && data?.priceId && fetchFunctionRef.current) {
      fetchFunctionRef.current(true);
    }
  }, [visible, data?.priceId]);
  
  const handleOffline = useCallback(() => {
    setIsOnline(false);
    message.warning('📴 Offline mode - using cache only', 1.5);
  }, []);
  
  // Memoized reset state function
  const resetModalState = useCallback(() => {
    setUsingCache(false);
    setCacheInfo(null);
    setIsFirstLoad(true);
  }, []);
  
  // Memoized load data function
  const loadDataOnModalOpen = useCallback(() => {
    if (visible && data?.priceId && fetchFunctionRef.current) {
      const hasValidCache = persistentCache.has(cacheKey);
      
      if (hasValidCache) {
        console.log('🎯 Valid cache available! Loading instantly without network request...');
      } else {
        console.log('💨 No cache yet, will fetch from server once');
      }
      
      fetchFunctionRef.current(false);
    }
  }, [visible, data?.priceId, cacheKey]);
  
  // Memoized cleanup function
  const cleanupResources = useCallback(() => {
    if (abortController.current) {
      abortController.current.abort();
    }
    if (loadingInterval.current) {
      clearInterval(loadingInterval.current);
    }
  }, []);
  
  // Memoized unmount cleanup
  const unmountCleanup = useCallback(() => {
    isMounted.current = false;
    cleanupResources();
  }, [cleanupResources]);
  
  // ============ OPTIMIZED EFFECTS USING USECALLBACK ============
  
  // Network status monitoring effect - using memoized handlers
  const networkEffectCallback = useCallback(() => {
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [handleOnline, handleOffline]);
  
  useEffect(networkEffectCallback, [networkEffectCallback]);
  
  // Load data when modal opens effect
  const modalOpenEffectCallback = useCallback(() => {
    loadDataOnModalOpen();
    return cleanupResources;
  }, [loadDataOnModalOpen, cleanupResources]);
  
  useEffect(modalOpenEffectCallback, [modalOpenEffectCallback]);
  
  // Reset state when modal closes effect
  const modalCloseEffectCallback = useCallback(() => {
    if (!visible) {
      resetModalState();
    }
  }, [visible, resetModalState]);
  
  useEffect(modalCloseEffectCallback, [modalCloseEffectCallback]);
  
  // Cleanup on unmount effect
  const unmountEffectCallback = useCallback(() => {
    return unmountCleanup;
  }, [unmountCleanup]);
  
  useEffect(unmountEffectCallback, [unmountEffectCallback]);
  
  // ============ MEMOIZED RENDER COMPONENTS ============
  
  const progressBarElement = useMemo(() => {
    if (progressWidth > 0 && progressWidth < 100 && spin && !usingCache) {
      return React.createElement('div', { 
        style: {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 10000,
          height: 2,
          background: '#f0f0f0'
        }
      },
        React.createElement('div', { 
          className: 'progress-bar', 
          style: { width: Math.min(progressWidth, 100) + '%' } 
        })
      );
    }
    return null;
  }, [progressWidth, spin, usingCache]);
  
  const offlineBannerElement = useMemo(() => {
    if (!isOnline) {
      return React.createElement('div', { 
        style: {
          position: 'fixed',
          top: 60,
          right: 20,
          zIndex: 10000,
          background: '#fff1f0',
          border: '1px solid #ffccc7',
          borderRadius: 8,
          padding: '6px 12px',
          fontSize: 11,
          color: '#ff4d4f',
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }
      },
        React.createElement(Icon, { type: 'disconnect' }),
        React.createElement('span', null, 'Offline mode')
      );
    }
    return null;
  }, [isOnline]);
  
  const cacheBadgeElement = useMemo(() => {
    if (usingCache && !loadingCache) {
      return React.createElement('span', { 
        title: cacheInfo ? `Cached ${cacheInfo.ageMinutes} minutes ago • Expires in ${cacheInfo.expiresIn} min` : 'From cache',
        style: {
          display: 'inline-flex', alignItems: 'center', gap: 5,
          background: 'rgba(82,196,26,0.2)',
          border: '1px solid rgba(82,196,26,0.35)',
          borderRadius: 20, padding: '3px 10px',
          fontSize: 10, fontWeight: 700, color: '#52c41a',
          cursor: 'help'
        } 
      },
        React.createElement(Icon, { type: 'thunderbolt', style: { fontSize: 10 } }),
        'CACHED ⚡',
        cacheInfo && React.createElement('span', { style: { marginLeft: 4, fontSize: 9 } }, 
          cacheInfo.ageMinutes < 60 ? `${cacheInfo.ageMinutes}m` : `${Math.floor(cacheInfo.ageMinutes / 60)}h`
        )
      );
    }
    return null;
  }, [usingCache, loadingCache, cacheInfo]);
  
  const offlineBadgeElement = useMemo(() => {
    if (!isOnline) {
      return React.createElement('span', { 
        style: {
          display: 'inline-flex', alignItems: 'center', gap: 5,
          background: 'rgba(255,77,79,0.2)',
          border: '1px solid rgba(255,77,79,0.35)',
          borderRadius: 20, padding: '3px 10px',
          fontSize: 10, fontWeight: 700, color: '#ff4d4f',
        }
      },
        React.createElement(Icon, { type: 'disconnect', style: { fontSize: 10 } }),
        'OFFLINE'
      );
    }
    return null;
  }, [isOnline]);
  
  const requestBadgeElement = useMemo(() => {
    return React.createElement('span', { 
      style: {
        display: 'inline-flex', alignItems: 'center', gap: 6,
        padding: '4px 12px',
        borderRadius: 20,
        background: 'rgba(255,255,255,0.15)',
        border: '1px solid rgba(255,255,255,0.25)',
        color: '#fff',
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: '.5px'
      }
    },
      React.createElement('span', { 
        style: { 
          width: 8, 
          height: 8, 
          borderRadius: '50%', 
          background: '#52c41a', 
          boxShadow: '0 0 5px #52c41a' 
        } 
      }),
      'REQ #', data?.priceId || 'N/A'
    );
  }, [data?.priceId]);
  
  const modalTitleElement = useMemo(() => {
    return React.createElement('div', { className: 'cd-header' },
      React.createElement('div', { className: 'cd-header-icon' },
        React.createElement('svg', { viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
          React.createElement('path', { d: 'M3 6H21V19H3V6Z', stroke: 'white', strokeWidth: '1.5', strokeLinejoin: 'round' }),
          React.createElement('path', { d: 'M8 10H16', stroke: 'white', strokeWidth: '1.5', strokeLinecap: 'round' }),
          React.createElement('path', { d: 'M8 14H12', stroke: 'white', strokeWidth: '1.5', strokeLinecap: 'round' }),
          React.createElement('path', { d: 'M7 3L9 6', stroke: 'white', strokeWidth: '1.5', strokeLinecap: 'round' }),
          React.createElement('path', { d: 'M17 3L15 6', stroke: 'white', strokeWidth: '1.5', strokeLinecap: 'round' })
        )
      ),
      React.createElement('div', null,
        React.createElement('div', { className: 'cd-header-title' }, 'PURCHASE REQUEST DETAILS'),
        React.createElement('div', { className: 'cd-header-sub' },
          'PO #', data?.poNumber || 'N/A', ' • JO #', data?.joNum || 'N/A'
        )
      ),
      React.createElement('div', { style: { marginLeft: 'auto', display: 'flex', gap: 8 } },
        cacheBadgeElement,
        offlineBadgeElement,
        requestBadgeElement
      )
    );
  }, [data?.poNumber, data?.joNum, cacheBadgeElement, offlineBadgeElement, requestBadgeElement]);
  
  return React.createElement(React.Fragment, null,
    React.createElement('style', null, modalStyles),
    progressBarElement,
    offlineBannerElement,
    React.createElement(Modal, {
      className: 'cd-modal',
      visible: visible,
      footer: null,
      width: 1000,
      onCancel: handleCloseModal,
      title: modalTitleElement
    },
      React.createElement(Spin, { 
        spinning: spin && !usingCache, 
        tip: loadingCache ? 'Loading...' : 'Fetching details...' 
      },
        React.createElement('div', { className: 'cd-spin-container' },
          React.createElement(Suspense, { 
            fallback: React.createElement('div', { 
              style: { padding: 40, textAlign: 'center' } 
            }, React.createElement(Spin, null)) 
          },
            React.createElement(PrSummary, {
              prTotal: prTotal,
              withExistingRm: hasExistingRm,
              itemTotalBudget: itemTotalBudget
            })
          ),
          React.createElement('div', { className: 'cd-body', style: { paddingTop: 0 } },
            React.createElement('div', { className: 'cd-section-title' },
              React.createElement(Icon, { type: 'file-text', style: { fontSize: 14, color: '#003a8c' } }),
              'PURCHASE REQUISITION ITEMS'
            ),
            React.createElement(Suspense, { 
              fallback: React.createElement('div', { 
                style: { padding: 20, textAlign: 'center' } 
              }, React.createElement(Spin, null)) 
            },
              React.createElement(PrItemTable, { prItems: details.prItems })
            ),
            React.createElement('div', { className: 'cd-section-title' },
              React.createElement(Icon, { type: 'shopping', style: { fontSize: 14, color: '#003a8c' } }),
              'PURCHASE ORDER DETAILS'
            ),
            React.createElement(Suspense, { 
              fallback: React.createElement('div', { 
                style: { padding: 20, textAlign: 'center' } 
              }, React.createElement(Spin, null)) 
            },
              React.createElement(PoDetails, {
                poDetails: details.poDetails,
                poItems: details.poItems,
                poHistory: details.poHistory
              })
            )
          )
        )
      )
    )
  );
};

PrInformationModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  closeModal: PropTypes.func.isRequired,
  getPrDetails: PropTypes.func.isRequired,
};

export default PrInformationModal;